(function() {
    'use strict';
    class MediaListCard {
        constructor(CoreUserService, $translate, $sce, $mdDialog, $mdToast, ContactManagerTagService, DialogService) {
            this.coreUserService = CoreUserService;
            this.$translate = $translate;
            this.$sce = $sce;
            this.$mdDialog = $mdDialog;
            this.$mdToast = $mdToast;
            this.ContactManagerTagService = ContactManagerTagService;
            this.DialogService = DialogService;
            this.successToastMessage = $translate.instant('icm-web__media-lists--toast-list-updated');
            this.addDescriptionString = this.$translate.instant('icm-web__media-list-engagement--add-description');
        }

        $onInit() {
            this.coreUserService.getCurrent(true).then((user) => {
                let userLanguage = user.language || 'en';

                switch(userLanguage) {
                    case 'zh_CN':
                    case 'zh_TW':
                        userLanguage = 'zh';
                        break;
                }

                if (this.mediaList.created) {
                    this.mediaList.createdOn = this._formatDate(new Date(this.mediaList.created), userLanguage);
                }

                if (this.mediaList.createdByFirstName || this.mediaList.createdByLastName) {
                    this.mediaList.createdBy = [this.mediaList.createdByFirstName, this.mediaList.createdByLastName].filter(name => !!name).join(' ');
                }

                if (this.mediaList.updated) {
                    this.mediaList.updatedAt = this._formatDate(new Date(this.mediaList.updated), userLanguage);
                }
                if (this.mediaList.lastUpdatedByFirstName || this.mediaList.lastUpdatedByLastName) {
                    this.mediaList.updatedBy = [this.mediaList.lastUpdatedByFirstName, this.mediaList.lastUpdatedByLastName].filter(name => !!name).join(' ');
                }
            });
        }

        _formatDate(dateObj, userLanguage) {
            return dateObj.toLocaleString(userLanguage, { month: 'short'  }) + ' ' +
                dateObj.toLocaleString(userLanguage, { day: 'numeric' }) + ', ' +
                dateObj.toLocaleString(userLanguage, { year: 'numeric'});
        }

        showDeleteDialog(ev, item){
            this.$mdDialog.show(
                this.$mdDialog.mwConfirm()
                    .class('icm-confirmation-modal')
                    .title(this.$translate.instant('icm-medialist__delete-medialist--confirm-modal-title'))
                    .htmlContent(this.$sce.trustAsHtml('<p class="mw-dialog__text-content">' + this.$translate.instant('icm-medialist__delete-medialist--confirm-modal-content-2') + '</p>'))
                    .ok(this.$translate.instant('action-label__delete'))
                    .cancel(this.$translate.instant('action-label__cancel'))
                    .targetEvent(ev)
            ).then(() => {
                if(item.id){
                    this.ContactManagerTagService.removeMediaList(item.id).then(()=>{
                        this.reloadCurrentPage();
                        this.$mdToast.show(
                            this.$mdToast.mwSimpleTimed().textContent(this.$translate.instant('icm-medialist__delete-medialist--success-message'))
                        );
                    });
                }
            })
            .catch(() => {});
        }

        showEditDialog(event, item){
            let _this = this;

            this.$mdDialog.show({
                bindToController: true,
                targetEvent: event,
                locals: {
                    mediaList: angular.copy(item),
                    duplicateError: false,
                    cancelDialog: function() {
                        _this.$mdDialog.cancel();
                    },
                    okDialog: function(updatedMediaList) {
                        let mediaListId = updatedMediaList.id;
                        let mediaListName = updatedMediaList.name;
                        let mediaListDescription = updatedMediaList.description;

                        this.duplicateError = false;

                        _this.ContactManagerTagService.updateMediaList(mediaListId, mediaListName, mediaListDescription)
                            .then(() => {
                                _this.reloadCurrentPage();
                                _this.$mdDialog.hide();

                                _this.$mdToast.show(
                                    _this.$mdToast.mwSimpleTimed().textContent(_this.successToastMessage)
                                );
                            })
                            .catch((error) => {
                                // somewhere along the line we decided error.status just wasn't cutting it, we thought error.data.error.reason just rolled off the tongue
                                if(error.status === 409 || (error && error.data && error.data.error && error.data.error.reason === 409)) {
                                    this.duplicateError = true;
                                } else {
                                    _this.$mdDialog.hide();
                                    _this.DialogService.flashError(_this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                                }
                            });
                    },
                },
                template: `
                    <md-dialog id="icm-media-list-update-modal" class="mw-mini-modal" aria-label="" layout="column">
                        <mw-media-list-update-modal class="mw-mini-modal-wrapper" layout="column" media-list="$ctrl.mediaList" duplicate-error="$ctrl.duplicateError" ok-callback="$ctrl.okDialog(updatedMediaList)" cancel-callback="$ctrl.cancelDialog()"></mw-media-list-update-modal>
                    </md-dialog>
                `,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl'
            });
        }
    }

    angular
        .module('MW.ContactManager.MwMediaListCard', [
            'MW.CoreStream.ContactManagerTagService',
            'MW.Influencers.IcmDialogService',
            'MW.Framework.CoreUserService'
        ])
        .component('mwMediaListCard', {
            bindings: {
                mediaList: '<',
                reloadCurrentPage: '&'
            },
            controller: [
                'CoreUserService',
                '$translate',
                '$sce',
                '$mdDialog',
                '$mdToast',
                'ContactManagerTagService',
                'DialogService',
                MediaListCard
            ],
            template: `
                <div class="md-card">
                    <div class="md-card-content" layout="column">
                        <div class="list-header-row" layout="row" layout-align="space-between start">
                            <a href="influencers/contact-list/{{$ctrl.mediaList.id}}" class="list-name">
                                {{$ctrl.mediaList.name}}
                                <md-tooltip md-delay="500">
                                    {{$ctrl.mediaList.name}}
                                </md-tooltip>
                            </a>
                            <md-menu class="list-action-button" md-position-mode="target-right target" md-offset="0 50">
                                <mw-menu-trigger-icon-button class="diddly-dot" icon="navigation:ic_more_vert_24px" tooltip="{{::'mw-collection__tooltip-menu-trigger' | translate}}" on-click="$mdMenu.open($event)"></mw-menu-trigger-icon-button>
                                <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                    <mw-menu-item type="focusdummy"></mw-menu-item>
                                    <mw-menu-item class="automation-editListOption" icon="editor:ic_mode_edit_24px" on-click="$ctrl.showEditDialog($event, $ctrl.mediaList)">
                                        <span translate>icm-web__list-of-lists--edit-list</span>
                                    </mw-menu-item>
                                    <mw-menu-item class="automation-deleteListOption" icon="action:ic_delete_24px" on-click='$ctrl.showDeleteDialog($event, $ctrl.mediaList)'>
                                        <span translate>icm-web__list-of-lists--delete-list</span>
                                    </mw-menu-item>
                                </md-menu-content>
                            </md-menu>
                        </div>
                        <div class="list-data-row" layout="row" layout-wrap>
                            <div class="list-details-section" layout="column" layout-align="space-between" flex="100" flex-gt-sm="50">
                                <div class="list-description-wrapper" layout="row" layout-align="start end">
                                    <div ng-if="$ctrl.mediaList.description" class="list-description">
                                        <span>{{$ctrl.mediaList.description}}</span>
                                    </div>
                                    <div ng-if="!$ctrl.mediaList.description" class="add-description" ng-click="$ctrl.showEditDialog($event, $ctrl.mediaList)">
                                        <span class="add-description-plus">+</span>
                                        <span class="add-description-label">{{$ctrl.addDescriptionString}}</span>
                                    </div>
                                </div>
                                <div>
                                    <div flex class="list-time" layout="row" layout-align="start end">
                                        <span translate>icm-web__list-card--created-on</span>
                                        <b>&nbsp;{{$ctrl.mediaList.createdOn}}</b>
                                        <span ng-if="$ctrl.mediaList.createdBy">&nbsp;&bull;&nbsp;</span>
                                        <span ng-if="$ctrl.mediaList.createdBy" translate>icm-web__list-card--created-by</span>
                                        <b class="modified-name" ng-if="$ctrl.mediaList.createdBy">
                                            &nbsp;{{$ctrl.mediaList.createdBy}}
                                            <md-tooltip md-delay="500">
                                                {{$ctrl.mediaList.createdBy}}
                                            </md-tooltip>
                                        </b>
                                    </div>
                                    <div flex class="list-time" layout="row" layout-align="start end">
                                        <span translate>icm-web__list-card--last-updated-on</span>
                                        <b>&nbsp;{{$ctrl.mediaList.updatedAt}}</b>
                                        <span ng-if="$ctrl.mediaList.updatedBy">&nbsp;&bull;&nbsp;</span>
                                        <span ng-if="$ctrl.mediaList.updatedBy" translate>icm-web__list-card--last-updated-by</span>
                                        <b class="modified-name" ng-if="$ctrl.mediaList.updatedBy">
                                            &nbsp;{{$ctrl.mediaList.updatedBy}}
                                            <md-tooltip md-delay="500">
                                                {{$ctrl.mediaList.updatedBy}}
                                            </md-tooltip>
                                        </b>
                                    </div>
                                </div>
                            </div>
                            <div class="list-data-spacer" hide-gt-sm></div>
                            <div class="list-stats-section" layout="column" layout-align="space-between" flex="100" flex-gt-sm="50">
                                <div layout="row" layout-align="space-between stretch">
                                    <div class="stat" layout="column" layout-align="center center" flex="25">
                                        <span class="stat-value">{{$ctrl.mediaList.distributions}}</span>
                                        <span class="stat-name" translate>icm-web__media-list-engagement--emails-sent</span>
                                    </div>
                                    <div class="stat" layout="column" layout-align="center center" flex="25">
                                        <span class="stat-value">{{$ctrl.mediaList.openRate}}%</span>
                                        <span class="stat-name" translate>icm-web__media-list-engagement--open-rate</span>
                                    </div>
                                    <div class="stat" layout="column" layout-align="center center" flex="25">
                                        <span class="stat-value">{{$ctrl.mediaList.clickToOpenRate}}%</span>
                                        <span class="stat-name" translate>icm-web__media-list-engagement--click-rate</span>
                                    </div>
                                    <div class="stat" layout="column" layout-align="center center" flex="25">
                                        <span class="stat-value">{{$ctrl.mediaList.unsubscribeRate}}%</span>
                                        <span class="stat-name" translate>icm-web__media-list-engagement--unsubscribe-rate</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `
        });
}());
